import apiClient from '../client';
import { Make, Model, SubModel, BodyStyle, DriveType, TransmissionType } from '../../../../shared/types';

export const vcdbService = {
  async getMakes(): Promise<Make[]> {
    const response = await apiClient.get<Make[]>('/vcdb/makes');
    return response.data;
  },

  async getModels(makeId: number): Promise<Model[]> {
    const response = await apiClient.get<Model[]>(`/vcdb/models/${makeId}`);
    return response.data;
  },

  async getSubModels(makeId: number, modelId: number): Promise<SubModel[]> {
    const response = await apiClient.get<SubModel[]>(`/vcdb/submodels/${makeId}/${modelId}`);
    return response.data;
  },

  /** subModelId = 0 means no submodel filter */
  async getYears(makeId: number, modelId: number, subModelId: number): Promise<number[]> {
    const response = await apiClient.get<number[]>(`/vcdb/years/${makeId}/${modelId}/${subModelId}`);
    return response.data;
  },

  async getBodyStyles(
    makeId: number, modelId: number, subModelId: number,
    fromYear: number, toYear: number
  ): Promise<BodyStyle[]> {
    const response = await apiClient.get<BodyStyle[]>(
      `/vcdb/body-styles/${makeId}/${modelId}/${subModelId}/${fromYear}/${toYear}`
    );
    return response.data;
  },

  async getDriveTypes(
    makeId: number, modelId: number, subModelId: number,
    fromYear: number, toYear: number
  ): Promise<DriveType[]> {
    const response = await apiClient.get<DriveType[]>(
      `/vcdb/drive-types/${makeId}/${modelId}/${subModelId}/${fromYear}/${toYear}`
    );
    return response.data;
  },

  async getTransmissionTypes(
    makeId: number, modelId: number, subModelId: number,
    fromYear: number, toYear: number
  ): Promise<TransmissionType[]> {
    const response = await apiClient.get<TransmissionType[]>(
      `/vcdb/transmission-types/${makeId}/${modelId}/${subModelId}/${fromYear}/${toYear}`
    );
    return response.data;
  },
};
